import { HStack, Img, Stack, Text } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { v4 } from 'uuid';
import { PROTECTED_PATHS } from '../../../app/constants';
import { dynamicPathhandler } from '../../../components/utils/dynamicPathHandler';

export const ArchivedProducts = ({ data }) => {
  const { VIEW_ONE_ARCHIEVED_PRODUCT } = PROTECTED_PATHS;
  const parentPath = dynamicPathhandler(VIEW_ONE_ARCHIEVED_PRODUCT);

  return (
    <Stack spacing='5'>
      {data?.map((item) => (
        <Link to={`${parentPath}/${item._id}`} key={v4()}>
          <HStack key={v4()} gap='1rem' bg='gray.50' shadow='sm' p='1'>
            <Img w='75px' h='75px' src={item?.imageUrl[0]} alt='product' />
            <Stack>
              <Text fontSize='1rem'>{item?.itemName}</Text>
              <Text fontSize='1.2rem' fontWeight={600}>
                {item?.price} NGN
              </Text>
            </Stack>
          </HStack>
        </Link>
      ))}
    </Stack>
  );
};
